import { fetch } from '@/shared/fetch';
import { FileEntity } from '@/shared/interfaces';

export const sendDoctorFile = async (fileEntity: FileEntity) => {
    const formData = new FormData();
    formData.append('file', fileEntity.file);
    return await fetch<string>(
        '/api/files/doctor-upload',
        'POST',
        formData,
        'AUTOMATIC',
    );
};

export const sendReferralFile = async (fileEntity: FileEntity) => {
    const formData = new FormData();
    formData.append('file', fileEntity.file);
    return await fetch<string>(
        '/api/files/referral-upload',
        'POST',
        formData,
        'AUTOMATIC',
    );
};

export const sendPatientFile = async (fileEntity: FileEntity) => {
    const formData = new FormData();
    formData.append('file', fileEntity.file);
    return await fetch<string>(
        '/api/files/upload',
        'POST',
        formData,
        'AUTOMATIC',
    );
};
